import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notifPanel", "accountPanel"]
  static values  = { animDuration: { type: Number, default: 210 } }

  connect() {
    this._outside = this._outside.bind(this)
    document.addEventListener("click", this._outside)
  }

  disconnect() {
    document.removeEventListener("click", this._outside)
  }

  toggleNotif(e) {
    e.stopPropagation()
    this._isOpen(this.notifPanelTarget)
      ? this._close(this.notifPanelTarget)
      : (this._isOpen(this.accountPanelTarget) && this._close(this.accountPanelTarget),
         this._open(this.notifPanelTarget))
  }

  toggleAccount(e) {
    e.stopPropagation()
    this._isOpen(this.accountPanelTarget)
      ? this._close(this.accountPanelTarget)
      : (this._isOpen(this.notifPanelTarget) && this._close(this.notifPanelTarget),
         this._open(this.accountPanelTarget))
  }

  _open(el) {
    el.style.visibility = ""
    el.style.pointerEvents = ""
    el.style.animation = "a2DropIn 220ms ease-out"
    el.dataset.open = "true"
  }

  _close(el) {
    el.style.animation = "a2DropOut 200ms ease-in forwards"
    el.dataset.open = ""
    setTimeout(() => {
      el.style.visibility = "hidden"
      el.style.animation = ""
    }, this.animDurationValue)
  }

  _isOpen(el) { return el.dataset.open === "true" }

  _outside(e) {
    if (!this.element.contains(e.target)) {
      if (this._isOpen(this.notifPanelTarget))    this._close(this.notifPanelTarget)
      if (this._isOpen(this.accountPanelTarget))  this._close(this.accountPanelTarget)
    }
  }
}